import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RateListGeneratorService } from '../../../../Services/Rate_List_Generator/rate-list-generator.service';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-rate-list-invoice',
  standalone: true,
  imports: [NgFor, NgIf,CommonModule,],
  templateUrl: './rate-list-invoice.component.html',
  styleUrl: './rate-list-invoice.component.css'
})
export class RateListInvoiceComponent implements OnInit {
  rateList: any[] = [];
  categories: any[] = []; // will store id + key
  categoryNames: { [key: string]: string } = {};
  categoryWiseItems: { [key: string]: any[] } = {};
  categoryFooter: { [key: string]: { label: string; value: string } } = {}; // ✅ new
  customerType!: string;

  constructor(
    private route: ActivatedRoute,
    private rateListGeneratorService: RateListGeneratorService
  ) {}

  ngOnInit(): void {
    const ids = this.route.snapshot.paramMap.get('id'); // e.g. "1,2,3"

    if (ids) {
      const idArray = ids.split(',').map(x => +x);

      const requests = idArray.map(id =>
        this.rateListGeneratorService.getRateListById(id)
      );

      forkJoin(requests).subscribe((responses: any[]) => {
        // Merge all results into one array
        this.rateList = responses.flatMap(res =>
          Array.isArray(res.data) ? res.data : [res.data]
        );

        console.log('Final Merged Rate List:', this.rateList);

        // ✅ GET CUSTOMER TYPE (store once)
      if (this.rateList.length > 0) {
        this.customerType = this.rateList[0].rlg_customer_type;
      }

        // Build categories
        const categoryMap = new Map<number, string>();

        this.rateList.forEach((item: any) => {
          if (item.category) {
            categoryMap.set(item.rlg_product_category, item.category.name);
          }
        });

        this.categories = Array.from(categoryMap.keys());


        this.categories.forEach(category => {
          
          this.categoryWiseItems[category] = this.rateList.filter(
            (x: any) => x.rlg_product_category === category
          );
        
          // ✅ store name per category
          this.categoryNames[category] =
            this.categoryWiseItems[category]?.[0]?.category?.name ?? '-';

          // ✅ capture special "Below on MRP" footer
          const belowRule = this.categoryWiseItems[category].find(
            (x: any) =>
              x.rlg_unit === 'By MRP' &&
              (x.rlg_below ?? '').toString().trim().toLowerCase() === 'yes'
          );

          if (belowRule) {
            this.categoryFooter[category] = {
              label: `Below ${belowRule.rlg_min_weight_range} On MRP`,
              value: `${belowRule.rlg_discount}% Off On MRP`
            };

            // Optionally remove it from main list so it won’t render twice
            this.categoryWiseItems[category] =
              this.categoryWiseItems[category].filter(x => x !== belowRule);
          }
        });

        // setTimeout(() => window.print(), 500);
      });
    }
  }

  printInvoice() {
    const printContents = document.getElementById('print-section')?.innerHTML;
    if (printContents) {
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // layout restore karne ke liye
    } // Recommended: use CSS @media print to hide buttons
  }


  formatWeightRange(item: any): string {
    console.log(
      `ID=${item.rlg_id}, min=${item.rlg_min_weight_range}, max=${item.rlg_max_weight_range}, above=${item.rlg_above}, below=${item.rlg_below}, custom=${item.rlg_weight_range}`
    );

    const above = (item.rlg_above ?? '').toString().trim().toLowerCase();
    const below = (item.rlg_below ?? '').toString().trim().toLowerCase();

    // Case 1: Max + Above
    if (item.rlg_max_weight_range === null && above === 'yes') {
      return `${item.rlg_min_weight_range} - Above`;
    }

    // Case 2: Min–Max
    if (item.rlg_min_weight_range != null && item.rlg_max_weight_range != null) {
      return `${item.rlg_min_weight_range} - ${item.rlg_max_weight_range}`;
    }

    // Case 3: Min + Above
    if (item.rlg_max_weight_range != null && above === 'yes') {
      return `${item.rlg_min_weight_range} - Above`;
    }

    // Case 4: Below
    if (item.rlg_min_weight_range === null && below === 'yes') {
      return `Below - ${item.rlg_max_weight_range}`;
    }

    if (above === 'yes' && below === 'yes') {
      return `All (Below - Above)`;
    }

    // // Case 5: Custom (only if nothing else matched)
    // if (
    //   !item.rlg_min_weight_range &&
    //   !item.rlg_max_weight_range &&
    //   above !== 'yes' &&
    //   below !== 'yes' &&
    //   item.rlg_weight_range
    // ) {
    //   return item.rlg_weight_range;
    // }
    return '-';
  }


}
